var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card__header"},[_c('div',{staticClass:"card__header__name"},[_vm._v(" "+_vm._s(_vm.$t(_vm.name))+" ")]),_c('img',{staticClass:"card__close",attrs:{"src":"/asset/icons/close.svg"},on:{"click":function($event){return _vm.$emit('removeCard')}}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }